// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/transportation/reports/bunker.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { OffsetDateTime } from "../../../common/date_time/date_time";
import { EmptyRequest } from "../../../common/messages/messages";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "services.transportation.reports";

export interface BunkeringSof {
  alongside: OffsetDateTime | undefined;
  hoseConnected: OffsetDateTime | undefined;
  commencedPumping: OffsetDateTime | undefined;
  completedPumping: OffsetDateTime | undefined;
  hoseDisconnected: OffsetDateTime | undefined;
}

export interface BunkeringSpec {
  viscosity?: number | undefined;
  density?: number | undefined;
  water?: number | undefined;
  sulphur?: number | undefined;
  flashPoint?: number | undefined;
}

export interface BunkeringDeliveryNote {
  fileId: string;
  fuelFileIds: string[];
  bdnNumber: string;
  vesselName: string;
  vesselImo: string;
  date: OffsetDateTime | undefined;
  sof: BunkeringSof | undefined;
  product: string;
  quantity: number;
  isDeleted?: boolean | undefined;
  supplierOrganisationId: string;
  locationOrganisationId: string;
  spec: BunkeringSpec | undefined;
  priorRob?: number | undefined;
}

export interface GetBunkersRequest {
  vesselImo: string;
}

export interface GetBunkersResponse {
  bunkers: BunkeringDeliveryNote[];
}

export interface GetUpdatedBunkersRequest {
  vesselImo: string;
  since: string | undefined;
}

export interface GetBunkeringDeliveryNoteRequest {
  vesselImo: string;
  product: string;
  bdnNumber: string;
  timestamp: string | undefined;
}

export interface GetOneBunkeringDeliveryNoteResponse {
  data: BunkeringDeliveryNote | undefined;
  version: number;
}

export interface UpdateBunkeringDeliveryNoteRequest {
  data: BunkeringDeliveryNote | undefined;
  expectedVersion: number;
}

function createBaseBunkeringSof(): BunkeringSof {
  return {
    alongside: undefined,
    hoseConnected: undefined,
    commencedPumping: undefined,
    completedPumping: undefined,
    hoseDisconnected: undefined,
  };
}

export const BunkeringSof: MessageFns<BunkeringSof> = {
  encode(message: BunkeringSof, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.alongside !== undefined) {
      OffsetDateTime.encode(message.alongside, writer.uint32(10).fork()).join();
    }
    if (message.hoseConnected !== undefined) {
      OffsetDateTime.encode(message.hoseConnected, writer.uint32(18).fork()).join();
    }
    if (message.commencedPumping !== undefined) {
      OffsetDateTime.encode(message.commencedPumping, writer.uint32(26).fork()).join();
    }
    if (message.completedPumping !== undefined) {
      OffsetDateTime.encode(message.completedPumping, writer.uint32(34).fork()).join();
    }
    if (message.hoseDisconnected !== undefined) {
      OffsetDateTime.encode(message.hoseDisconnected, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BunkeringSof {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBunkeringSof();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.alongside = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.hoseConnected = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.commencedPumping = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.completedPumping = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.hoseDisconnected = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BunkeringSof {
    return {
      alongside: isSet(object.alongside) ? OffsetDateTime.fromJSON(object.alongside) : undefined,
      hoseConnected: isSet(object.hoseConnected)
        ? OffsetDateTime.fromJSON(object.hoseConnected)
        : isSet(object.hose_connected)
        ? OffsetDateTime.fromJSON(object.hose_connected)
        : undefined,
      commencedPumping: isSet(object.commencedPumping)
        ? OffsetDateTime.fromJSON(object.commencedPumping)
        : isSet(object.commenced_pumping)
        ? OffsetDateTime.fromJSON(object.commenced_pumping)
        : undefined,
      completedPumping: isSet(object.completedPumping)
        ? OffsetDateTime.fromJSON(object.completedPumping)
        : isSet(object.completed_pumping)
        ? OffsetDateTime.fromJSON(object.completed_pumping)
        : undefined,
      hoseDisconnected: isSet(object.hoseDisconnected)
        ? OffsetDateTime.fromJSON(object.hoseDisconnected)
        : isSet(object.hose_disconnected)
        ? OffsetDateTime.fromJSON(object.hose_disconnected)
        : undefined,
    };
  },

  toJSON(message: BunkeringSof): unknown {
    const obj: any = {};
    if (message.alongside !== undefined) {
      obj.alongside = OffsetDateTime.toJSON(message.alongside);
    }
    if (message.hoseConnected !== undefined) {
      obj.hoseConnected = OffsetDateTime.toJSON(message.hoseConnected);
    }
    if (message.commencedPumping !== undefined) {
      obj.commencedPumping = OffsetDateTime.toJSON(message.commencedPumping);
    }
    if (message.completedPumping !== undefined) {
      obj.completedPumping = OffsetDateTime.toJSON(message.completedPumping);
    }
    if (message.hoseDisconnected !== undefined) {
      obj.hoseDisconnected = OffsetDateTime.toJSON(message.hoseDisconnected);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BunkeringSof>, I>>(base?: I): BunkeringSof {
    return BunkeringSof.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BunkeringSof>, I>>(object: I): BunkeringSof {
    const message = createBaseBunkeringSof();
    message.alongside = (object.alongside !== undefined && object.alongside !== null)
      ? OffsetDateTime.fromPartial(object.alongside)
      : undefined;
    message.hoseConnected = (object.hoseConnected !== undefined && object.hoseConnected !== null)
      ? OffsetDateTime.fromPartial(object.hoseConnected)
      : undefined;
    message.commencedPumping = (object.commencedPumping !== undefined && object.commencedPumping !== null)
      ? OffsetDateTime.fromPartial(object.commencedPumping)
      : undefined;
    message.completedPumping = (object.completedPumping !== undefined && object.completedPumping !== null)
      ? OffsetDateTime.fromPartial(object.completedPumping)
      : undefined;
    message.hoseDisconnected = (object.hoseDisconnected !== undefined && object.hoseDisconnected !== null)
      ? OffsetDateTime.fromPartial(object.hoseDisconnected)
      : undefined;
    return message;
  },
};

function createBaseBunkeringSpec(): BunkeringSpec {
  return { viscosity: undefined, density: undefined, water: undefined, sulphur: undefined, flashPoint: undefined };
}

export const BunkeringSpec: MessageFns<BunkeringSpec> = {
  encode(message: BunkeringSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.viscosity !== undefined) {
      writer.uint32(9).double(message.viscosity);
    }
    if (message.density !== undefined) {
      writer.uint32(17).double(message.density);
    }
    if (message.water !== undefined) {
      writer.uint32(25).double(message.water);
    }
    if (message.sulphur !== undefined) {
      writer.uint32(33).double(message.sulphur);
    }
    if (message.flashPoint !== undefined) {
      writer.uint32(41).double(message.flashPoint);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BunkeringSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBunkeringSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.viscosity = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.density = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.water = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.sulphur = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.flashPoint = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BunkeringSpec {
    return {
      viscosity: isSet(object.viscosity) ? globalThis.Number(object.viscosity) : undefined,
      density: isSet(object.density) ? globalThis.Number(object.density) : undefined,
      water: isSet(object.water) ? globalThis.Number(object.water) : undefined,
      sulphur: isSet(object.sulphur) ? globalThis.Number(object.sulphur) : undefined,
      flashPoint: isSet(object.flashPoint)
        ? globalThis.Number(object.flashPoint)
        : isSet(object.flash_point)
        ? globalThis.Number(object.flash_point)
        : undefined,
    };
  },

  toJSON(message: BunkeringSpec): unknown {
    const obj: any = {};
    if (message.viscosity !== undefined) {
      obj.viscosity = message.viscosity;
    }
    if (message.density !== undefined) {
      obj.density = message.density;
    }
    if (message.water !== undefined) {
      obj.water = message.water;
    }
    if (message.sulphur !== undefined) {
      obj.sulphur = message.sulphur;
    }
    if (message.flashPoint !== undefined) {
      obj.flashPoint = message.flashPoint;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BunkeringSpec>, I>>(base?: I): BunkeringSpec {
    return BunkeringSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BunkeringSpec>, I>>(object: I): BunkeringSpec {
    const message = createBaseBunkeringSpec();
    message.viscosity = object.viscosity ?? undefined;
    message.density = object.density ?? undefined;
    message.water = object.water ?? undefined;
    message.sulphur = object.sulphur ?? undefined;
    message.flashPoint = object.flashPoint ?? undefined;
    return message;
  },
};

function createBaseBunkeringDeliveryNote(): BunkeringDeliveryNote {
  return {
    fileId: "",
    fuelFileIds: [],
    bdnNumber: "",
    vesselName: "",
    vesselImo: "",
    date: undefined,
    sof: undefined,
    product: "",
    quantity: 0,
    isDeleted: undefined,
    supplierOrganisationId: "",
    locationOrganisationId: "",
    spec: undefined,
    priorRob: undefined,
  };
}

export const BunkeringDeliveryNote: MessageFns<BunkeringDeliveryNote> = {
  encode(message: BunkeringDeliveryNote, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileId !== "") {
      writer.uint32(10).string(message.fileId);
    }
    for (const v of message.fuelFileIds) {
      writer.uint32(18).string(v!);
    }
    if (message.bdnNumber !== "") {
      writer.uint32(26).string(message.bdnNumber);
    }
    if (message.vesselName !== "") {
      writer.uint32(34).string(message.vesselName);
    }
    if (message.vesselImo !== "") {
      writer.uint32(42).string(message.vesselImo);
    }
    if (message.date !== undefined) {
      OffsetDateTime.encode(message.date, writer.uint32(50).fork()).join();
    }
    if (message.sof !== undefined) {
      BunkeringSof.encode(message.sof, writer.uint32(58).fork()).join();
    }
    if (message.product !== "") {
      writer.uint32(66).string(message.product);
    }
    if (message.quantity !== 0) {
      writer.uint32(73).double(message.quantity);
    }
    if (message.isDeleted !== undefined) {
      writer.uint32(80).bool(message.isDeleted);
    }
    if (message.supplierOrganisationId !== "") {
      writer.uint32(90).string(message.supplierOrganisationId);
    }
    if (message.locationOrganisationId !== "") {
      writer.uint32(98).string(message.locationOrganisationId);
    }
    if (message.spec !== undefined) {
      BunkeringSpec.encode(message.spec, writer.uint32(106).fork()).join();
    }
    if (message.priorRob !== undefined) {
      writer.uint32(113).double(message.priorRob);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BunkeringDeliveryNote {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBunkeringDeliveryNote();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fuelFileIds.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.bdnNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.vesselName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.date = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.sof = BunkeringSof.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.quantity = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.isDeleted = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.supplierOrganisationId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.locationOrganisationId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.spec = BunkeringSpec.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 113) {
            break;
          }

          message.priorRob = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BunkeringDeliveryNote {
    return {
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
      fuelFileIds: globalThis.Array.isArray(object?.fuelFileIds)
        ? object.fuelFileIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.fuel_file_ids)
        ? object.fuel_file_ids.map((e: any) => globalThis.String(e))
        : [],
      bdnNumber: isSet(object.bdnNumber)
        ? globalThis.String(object.bdnNumber)
        : isSet(object.bdn_number)
        ? globalThis.String(object.bdn_number)
        : "",
      vesselName: isSet(object.vesselName)
        ? globalThis.String(object.vesselName)
        : isSet(object.vessel_name)
        ? globalThis.String(object.vessel_name)
        : "",
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      date: isSet(object.date) ? OffsetDateTime.fromJSON(object.date) : undefined,
      sof: isSet(object.sof) ? BunkeringSof.fromJSON(object.sof) : undefined,
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      isDeleted: isSet(object.isDeleted)
        ? globalThis.Boolean(object.isDeleted)
        : isSet(object.is_deleted)
        ? globalThis.Boolean(object.is_deleted)
        : undefined,
      supplierOrganisationId: isSet(object.supplierOrganisationId)
        ? globalThis.String(object.supplierOrganisationId)
        : isSet(object.supplier_organisationId)
        ? globalThis.String(object.supplier_organisationId)
        : "",
      locationOrganisationId: isSet(object.locationOrganisationId)
        ? globalThis.String(object.locationOrganisationId)
        : isSet(object.location_organisationId)
        ? globalThis.String(object.location_organisationId)
        : "",
      spec: isSet(object.spec) ? BunkeringSpec.fromJSON(object.spec) : undefined,
      priorRob: isSet(object.priorRob)
        ? globalThis.Number(object.priorRob)
        : isSet(object.prior_rob)
        ? globalThis.Number(object.prior_rob)
        : undefined,
    };
  },

  toJSON(message: BunkeringDeliveryNote): unknown {
    const obj: any = {};
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.fuelFileIds?.length) {
      obj.fuelFileIds = message.fuelFileIds;
    }
    if (message.bdnNumber !== "") {
      obj.bdnNumber = message.bdnNumber;
    }
    if (message.vesselName !== "") {
      obj.vesselName = message.vesselName;
    }
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.date !== undefined) {
      obj.date = OffsetDateTime.toJSON(message.date);
    }
    if (message.sof !== undefined) {
      obj.sof = BunkeringSof.toJSON(message.sof);
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.quantity !== 0) {
      obj.quantity = message.quantity;
    }
    if (message.isDeleted !== undefined) {
      obj.isDeleted = message.isDeleted;
    }
    if (message.supplierOrganisationId !== "") {
      obj.supplierOrganisationId = message.supplierOrganisationId;
    }
    if (message.locationOrganisationId !== "") {
      obj.locationOrganisationId = message.locationOrganisationId;
    }
    if (message.spec !== undefined) {
      obj.spec = BunkeringSpec.toJSON(message.spec);
    }
    if (message.priorRob !== undefined) {
      obj.priorRob = message.priorRob;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BunkeringDeliveryNote>, I>>(base?: I): BunkeringDeliveryNote {
    return BunkeringDeliveryNote.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BunkeringDeliveryNote>, I>>(object: I): BunkeringDeliveryNote {
    const message = createBaseBunkeringDeliveryNote();
    message.fileId = object.fileId ?? "";
    message.fuelFileIds = object.fuelFileIds?.map((e) => e) || [];
    message.bdnNumber = object.bdnNumber ?? "";
    message.vesselName = object.vesselName ?? "";
    message.vesselImo = object.vesselImo ?? "";
    message.date = (object.date !== undefined && object.date !== null)
      ? OffsetDateTime.fromPartial(object.date)
      : undefined;
    message.sof = (object.sof !== undefined && object.sof !== null) ? BunkeringSof.fromPartial(object.sof) : undefined;
    message.product = object.product ?? "";
    message.quantity = object.quantity ?? 0;
    message.isDeleted = object.isDeleted ?? undefined;
    message.supplierOrganisationId = object.supplierOrganisationId ?? "";
    message.locationOrganisationId = object.locationOrganisationId ?? "";
    message.spec = (object.spec !== undefined && object.spec !== null)
      ? BunkeringSpec.fromPartial(object.spec)
      : undefined;
    message.priorRob = object.priorRob ?? undefined;
    return message;
  },
};

function createBaseGetBunkersRequest(): GetBunkersRequest {
  return { vesselImo: "" };
}

export const GetBunkersRequest: MessageFns<GetBunkersRequest> = {
  encode(message: GetBunkersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBunkersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBunkersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBunkersRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
    };
  },

  toJSON(message: GetBunkersRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBunkersRequest>, I>>(base?: I): GetBunkersRequest {
    return GetBunkersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBunkersRequest>, I>>(object: I): GetBunkersRequest {
    const message = createBaseGetBunkersRequest();
    message.vesselImo = object.vesselImo ?? "";
    return message;
  },
};

function createBaseGetBunkersResponse(): GetBunkersResponse {
  return { bunkers: [] };
}

export const GetBunkersResponse: MessageFns<GetBunkersResponse> = {
  encode(message: GetBunkersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.bunkers) {
      BunkeringDeliveryNote.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBunkersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBunkersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.bunkers.push(BunkeringDeliveryNote.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBunkersResponse {
    return {
      bunkers: globalThis.Array.isArray(object?.bunkers)
        ? object.bunkers.map((e: any) => BunkeringDeliveryNote.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetBunkersResponse): unknown {
    const obj: any = {};
    if (message.bunkers?.length) {
      obj.bunkers = message.bunkers.map((e) => BunkeringDeliveryNote.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBunkersResponse>, I>>(base?: I): GetBunkersResponse {
    return GetBunkersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBunkersResponse>, I>>(object: I): GetBunkersResponse {
    const message = createBaseGetBunkersResponse();
    message.bunkers = object.bunkers?.map((e) => BunkeringDeliveryNote.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetUpdatedBunkersRequest(): GetUpdatedBunkersRequest {
  return { vesselImo: "", since: undefined };
}

export const GetUpdatedBunkersRequest: MessageFns<GetUpdatedBunkersRequest> = {
  encode(message: GetUpdatedBunkersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    if (message.since !== undefined) {
      Timestamp.encode(toTimestamp(message.since), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUpdatedBunkersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUpdatedBunkersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.since = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUpdatedBunkersRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      since: isSet(object.since) ? globalThis.String(object.since) : undefined,
    };
  },

  toJSON(message: GetUpdatedBunkersRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.since !== undefined) {
      obj.since = message.since;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUpdatedBunkersRequest>, I>>(base?: I): GetUpdatedBunkersRequest {
    return GetUpdatedBunkersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUpdatedBunkersRequest>, I>>(object: I): GetUpdatedBunkersRequest {
    const message = createBaseGetUpdatedBunkersRequest();
    message.vesselImo = object.vesselImo ?? "";
    message.since = object.since ?? undefined;
    return message;
  },
};

function createBaseGetBunkeringDeliveryNoteRequest(): GetBunkeringDeliveryNoteRequest {
  return { vesselImo: "", product: "", bdnNumber: "", timestamp: undefined };
}

export const GetBunkeringDeliveryNoteRequest: MessageFns<GetBunkeringDeliveryNoteRequest> = {
  encode(message: GetBunkeringDeliveryNoteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    if (message.product !== "") {
      writer.uint32(18).string(message.product);
    }
    if (message.bdnNumber !== "") {
      writer.uint32(26).string(message.bdnNumber);
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBunkeringDeliveryNoteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBunkeringDeliveryNoteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.bdnNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBunkeringDeliveryNoteRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      bdnNumber: isSet(object.bdnNumber)
        ? globalThis.String(object.bdnNumber)
        : isSet(object.bdn_number)
        ? globalThis.String(object.bdn_number)
        : "",
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : undefined,
    };
  },

  toJSON(message: GetBunkeringDeliveryNoteRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.bdnNumber !== "") {
      obj.bdnNumber = message.bdnNumber;
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetBunkeringDeliveryNoteRequest>, I>>(base?: I): GetBunkeringDeliveryNoteRequest {
    return GetBunkeringDeliveryNoteRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetBunkeringDeliveryNoteRequest>, I>>(
    object: I,
  ): GetBunkeringDeliveryNoteRequest {
    const message = createBaseGetBunkeringDeliveryNoteRequest();
    message.vesselImo = object.vesselImo ?? "";
    message.product = object.product ?? "";
    message.bdnNumber = object.bdnNumber ?? "";
    message.timestamp = object.timestamp ?? undefined;
    return message;
  },
};

function createBaseGetOneBunkeringDeliveryNoteResponse(): GetOneBunkeringDeliveryNoteResponse {
  return { data: undefined, version: 0 };
}

export const GetOneBunkeringDeliveryNoteResponse: MessageFns<GetOneBunkeringDeliveryNoteResponse> = {
  encode(message: GetOneBunkeringDeliveryNoteResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      BunkeringDeliveryNote.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.version !== 0) {
      writer.uint32(16).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOneBunkeringDeliveryNoteResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOneBunkeringDeliveryNoteResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = BunkeringDeliveryNote.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOneBunkeringDeliveryNoteResponse {
    return {
      data: isSet(object.data) ? BunkeringDeliveryNote.fromJSON(object.data) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: GetOneBunkeringDeliveryNoteResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = BunkeringDeliveryNote.toJSON(message.data);
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOneBunkeringDeliveryNoteResponse>, I>>(
    base?: I,
  ): GetOneBunkeringDeliveryNoteResponse {
    return GetOneBunkeringDeliveryNoteResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOneBunkeringDeliveryNoteResponse>, I>>(
    object: I,
  ): GetOneBunkeringDeliveryNoteResponse {
    const message = createBaseGetOneBunkeringDeliveryNoteResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? BunkeringDeliveryNote.fromPartial(object.data)
      : undefined;
    message.version = object.version ?? 0;
    return message;
  },
};

function createBaseUpdateBunkeringDeliveryNoteRequest(): UpdateBunkeringDeliveryNoteRequest {
  return { data: undefined, expectedVersion: 0 };
}

export const UpdateBunkeringDeliveryNoteRequest: MessageFns<UpdateBunkeringDeliveryNoteRequest> = {
  encode(message: UpdateBunkeringDeliveryNoteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      BunkeringDeliveryNote.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.expectedVersion !== 0) {
      writer.uint32(16).int64(message.expectedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateBunkeringDeliveryNoteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateBunkeringDeliveryNoteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = BunkeringDeliveryNote.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.expectedVersion = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateBunkeringDeliveryNoteRequest {
    return {
      data: isSet(object.data) ? BunkeringDeliveryNote.fromJSON(object.data) : undefined,
      expectedVersion: isSet(object.expectedVersion)
        ? globalThis.Number(object.expectedVersion)
        : isSet(object.expected_version)
        ? globalThis.Number(object.expected_version)
        : 0,
    };
  },

  toJSON(message: UpdateBunkeringDeliveryNoteRequest): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = BunkeringDeliveryNote.toJSON(message.data);
    }
    if (message.expectedVersion !== 0) {
      obj.expectedVersion = Math.round(message.expectedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateBunkeringDeliveryNoteRequest>, I>>(
    base?: I,
  ): UpdateBunkeringDeliveryNoteRequest {
    return UpdateBunkeringDeliveryNoteRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateBunkeringDeliveryNoteRequest>, I>>(
    object: I,
  ): UpdateBunkeringDeliveryNoteRequest {
    const message = createBaseUpdateBunkeringDeliveryNoteRequest();
    message.data = (object.data !== undefined && object.data !== null)
      ? BunkeringDeliveryNote.fromPartial(object.data)
      : undefined;
    message.expectedVersion = object.expectedVersion ?? 0;
    return message;
  },
};

export interface BunkerService {
  addBunkerDeliveryNote(
    request: DeepPartial<BunkeringDeliveryNote>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneBunkeringDeliveryNoteResponse>;
  getOneBunkerDeliveryNote(
    request: DeepPartial<GetBunkeringDeliveryNoteRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneBunkeringDeliveryNoteResponse>;
  updateBunkerDeliveryNote(
    request: DeepPartial<UpdateBunkeringDeliveryNoteRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneBunkeringDeliveryNoteResponse>;
  getBunkers(request: DeepPartial<GetBunkersRequest>, metadata?: grpc.Metadata): Promise<GetBunkersResponse>;
  getUpdatedBunkers(
    request: DeepPartial<GetUpdatedBunkersRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetBunkersResponse>;
  getAllBunkers(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetBunkersResponse>;
}

export class BunkerServiceClientImpl implements BunkerService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.addBunkerDeliveryNote = this.addBunkerDeliveryNote.bind(this);
    this.getOneBunkerDeliveryNote = this.getOneBunkerDeliveryNote.bind(this);
    this.updateBunkerDeliveryNote = this.updateBunkerDeliveryNote.bind(this);
    this.getBunkers = this.getBunkers.bind(this);
    this.getUpdatedBunkers = this.getUpdatedBunkers.bind(this);
    this.getAllBunkers = this.getAllBunkers.bind(this);
  }

  addBunkerDeliveryNote(
    request: DeepPartial<BunkeringDeliveryNote>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneBunkeringDeliveryNoteResponse> {
    return this.rpc.unary(BunkerServiceAddBunkerDeliveryNoteDesc, BunkeringDeliveryNote.fromPartial(request), metadata);
  }

  getOneBunkerDeliveryNote(
    request: DeepPartial<GetBunkeringDeliveryNoteRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneBunkeringDeliveryNoteResponse> {
    return this.rpc.unary(
      BunkerServiceGetOneBunkerDeliveryNoteDesc,
      GetBunkeringDeliveryNoteRequest.fromPartial(request),
      metadata,
    );
  }

  updateBunkerDeliveryNote(
    request: DeepPartial<UpdateBunkeringDeliveryNoteRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneBunkeringDeliveryNoteResponse> {
    return this.rpc.unary(
      BunkerServiceUpdateBunkerDeliveryNoteDesc,
      UpdateBunkeringDeliveryNoteRequest.fromPartial(request),
      metadata,
    );
  }

  getBunkers(request: DeepPartial<GetBunkersRequest>, metadata?: grpc.Metadata): Promise<GetBunkersResponse> {
    return this.rpc.unary(BunkerServiceGetBunkersDesc, GetBunkersRequest.fromPartial(request), metadata);
  }

  getUpdatedBunkers(
    request: DeepPartial<GetUpdatedBunkersRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetBunkersResponse> {
    return this.rpc.unary(BunkerServiceGetUpdatedBunkersDesc, GetUpdatedBunkersRequest.fromPartial(request), metadata);
  }

  getAllBunkers(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetBunkersResponse> {
    return this.rpc.unary(BunkerServiceGetAllBunkersDesc, EmptyRequest.fromPartial(request), metadata);
  }
}

export const BunkerServiceDesc = { serviceName: "services.transportation.reports.BunkerService" };

export const BunkerServiceAddBunkerDeliveryNoteDesc: UnaryMethodDefinitionish = {
  methodName: "AddBunkerDeliveryNote",
  service: BunkerServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return BunkeringDeliveryNote.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetOneBunkeringDeliveryNoteResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const BunkerServiceGetOneBunkerDeliveryNoteDesc: UnaryMethodDefinitionish = {
  methodName: "GetOneBunkerDeliveryNote",
  service: BunkerServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetBunkeringDeliveryNoteRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetOneBunkeringDeliveryNoteResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const BunkerServiceUpdateBunkerDeliveryNoteDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateBunkerDeliveryNote",
  service: BunkerServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateBunkeringDeliveryNoteRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetOneBunkeringDeliveryNoteResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const BunkerServiceGetBunkersDesc: UnaryMethodDefinitionish = {
  methodName: "GetBunkers",
  service: BunkerServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetBunkersRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetBunkersResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const BunkerServiceGetUpdatedBunkersDesc: UnaryMethodDefinitionish = {
  methodName: "GetUpdatedBunkers",
  service: BunkerServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetUpdatedBunkersRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetBunkersResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const BunkerServiceGetAllBunkersDesc: UnaryMethodDefinitionish = {
  methodName: "GetAllBunkers",
  service: BunkerServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetBunkersResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
